export const AppUserCred = {
    username: 'appuser@gmail.com',
    // password: 'AppUser@123$',
    // client_id: '3OgO0IgPCA8VUhKfYt4pmtvmiaeUHgG3UBhkA86t',
    // client_secret: 'dRDg2B65QKTRlaT3hjoRdnWHky36SDYZlI3nZVdUMt1IJUcWpXNnlnrimUafkojlCOYkSjmumAfGDQvaZfnsM2BW8ZqmVKzaQZgpyhQpKeCgAw5SkMMx7ZrrCiphHZMw',
    password: 'AppUser@123$',
    client_id: 'oMvF8FZuMvxbaI1q1tZ4itDLpD9vEuZht2FG2SRp',
    client_secret: 'xqx99W8HUb4AxeAixjgPZhWVSC6SFCOwx1vO5DDVcjdsyD19nI2E8igetamczxz6elOiQJkQLmYkrEBOHMF0qQYYFrtRbcB5j614YlFAS1y9PeG0OqJcp0EuNK7UZbC7',
    grant_type: 'password'
};
